import React from "react";
import { Navigate } from "react-router-dom";

const PublicRoute = ({ element, restricted, ...rest }) => {
  const isAuthenticated = localStorage.getItem("coyote-token");
  return isAuthenticated && restricted ? (
    <Navigate to="/dashboard" />
  ) : (
    React.cloneElement(element, { ...rest })
  );
};

export default PublicRoute;
